import "../../assets/style/grandprix.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircuitLayout from "../../components/CircuitLayout";
import CircuitTransition from "../../components/CircuitTransition";
import {
  faCircleInfo,
  faCalendarDay,
  faLocationPin,
  faRuler,
  faBacon,
  faMapLocation,
  faTrophy,
  faStopwatch,
  faBolt,
  faMedal,
  faCarSide,
  faTriangleExclamation,
  faClock,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import { i18n } from "../../App";
import DateFormat from "../../components/DateFormat";
import Flag from "../../components/Flag";
import { DriverLink } from "../../components/FlagLink";
import ErrorPage from "../ErrorPage";
import { Link, useNavigate } from "react-router-dom";
import GrandPrixNavbar from "../../components/GrandPrix/GrandPrixNavbar";
import LoadingContent from "../../components/LoadingContent";
import SummaryData from "../../components/Historic/SummaryData";
import SummaryDrivers from "./index/SummaryDrivers";
import { useUser } from "../../components/UserContext";
import { processMilestoneAuto } from "../../utils/Milestones";
import SummaryResults from "../../components/GrandPrix/SummaryResults";
import Button from "../../components/Button";

const GrandPrix = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  let { grandprix } = useParams();
  const { superMode, user } = useUser() as any;
  const { t } = useTranslation();
  const [grandPrix, setGrandPrix] = useState<any>({
    name: "",
    pole_video: "",
    gp_video: "",
    conference: "",
    circuit_id: null,
    date: new Date(),
    circuit_name: "",
    layout: null,
    turns: 0,
    length: 0,
    flag_code: "unk",
    country: "",
    id: -1,
    champ_name: "",
    rally_circuits: "",
  });
  const [editingMilestoneIndex, setEditingMilestoneIndex] = useState<
    number | null
  >(null);
  const [editedMilestoneText, setEditedMilestoneText] = useState("");
  const [milestonesAuto, setMilestonesAuto] = useState([]);
  const [milestonesTrans, setMilestonesTrans] = useState([]);
  const [typeRaces, setTypeRaces] = useState(-1);
  const [drivers, setDrivers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [grandsPrixNames, setGrandsPrixNames] = useState([]);
  const [winner, setWinner] = useState([]);
  const [report, setReport] = useState<any>([]);

  const [poleman, setPoleman] = useState([]);
  const [fastestLap, setFastestLap] = useState([]);
  const [photoGP, setPhotoGP] = useState("");

  const [widthCont, setWidthCont] = useState("col-md-8");
  const [circuitContainer, setCircuitContainer] = useState(
    "gp-results-layout-container",
  );

  useEffect(() => {
    // 1. Reseteamos los contenedores a sus valores por defecto antes de cargar el nuevo GP
    setWidthCont("col-md-8");
    setCircuitContainer("gp-results-layout-container");
    setLoading(true);

    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getGrandPrixByName`,
        {
          params: {
            name: grandprix,
            language: i18n.language,
          },
        },
      )
      .then(({ data }) => {
        document.title = "LVF1 - " + data.grand_prix.name;
        setMilestonesAuto(data.milestones_auto);
        setMilestonesTrans(data.milestones_trans);
        setDrivers(data.drivers);
        setTeams(data.teams);
        setGrandsPrixNames(data.grandprix_names);
        setWinner(data.winner);
        setPoleman(data.poleman);
        setFastestLap(data.fastestLap);
        setGrandPrix(data.grand_prix);
        setTypeRaces(data.type_races);
        setReport(data.report);

        if (
          data.grand_prix.gp_video === null ||
          data.grand_prix.pole_video === null
        ) {
          if (data.hasImage != null && data.hasImage)
            setPhotoGP(`/assets/ImagesGP/${data.grand_prix.id}.jpg`);
          else if (
            data.grand_prix.pole_video === null &&
            data.grand_prix.gp_video === null
          ) {
            setWidthCont("col-md-12");
          }
        }

        // 2. Si el nuevo GP no tiene hitos, aplicamos la clase especial
        if (data.milestones_auto.length + data.milestones_trans.length == 0) {
          setCircuitContainer("gp-results-layout-containerx2");
        }

        setLoading(false);
      })
      .catch(({ response }) => {
        console.log(response?.data);
        setLoading(false);
        throw new Error(response?.data || response);
      });
  }, [i18n.language, grandprix]);

  const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& significa toda la cadena coincidente
  };
  const getMilestoneLinked = (milestone: string | null): any => {
    if (milestone == null) return milestone;
    let milestone_array: any[] = [milestone];

    // Función auxiliar para procesar colecciones de forma limpia
    const processEntities = (
      entities: any[],
      prefix: string,
      currentMilestone: any[],
    ) => {
      // Ordenar estrictamente de mayor a menor longitud para evitar conflictos parciales
      const sortedEntities = [...entities].sort((a: any, b: any) => {
        const nameA = a.username || a.name;
        const nameB = b.username || b.name;
        return nameB.length - nameA.length;
      });

      return sortedEntities.reduce((previous_milestone: any[], entity: any) => {
        const entityName = entity.username || entity.name;
        let return_milestone: any[] = previous_milestone.slice();

        for (var i = 0; i < previous_milestone.length; i++) {
          if (previous_milestone[i].startsWith("{")) {
            continue;
          }

          var escapedName = escapeRegExp(entityName);

          // Detectar si el primer y último carácter son alfanuméricos/word chars
          const startsWithWord = /\w/.test(entityName[0]);
          const endsWithWord = /\w/.test(entityName[entityName.length - 1]);

          // Límites adaptativos para soportar símbolos extraños al inicio o fin
          const startBoundary = startsWithWord ? "\\b" : "(?<!\\w)";
          const endBoundary = endsWithWord ? "\\b" : "(?!\\w)";

          var re = new RegExp(
            `${startBoundary}(${escapedName})${endBoundary}`,
            "gi",
          );

          if (!re.test(previous_milestone[i])) {
            continue;
          }

          // Reset lastIndex debido al uso de 'g' con .test()
          re.lastIndex = 0;
          var aux = previous_milestone[i].split(re);

          return_milestone.splice(i, 1);

          let offset = 0;
          for (var j = 0; j < aux.length; j++) {
            let segment: any = aux[j];
            // Comprobación insensible a mayúsculas/minúsculas pero respetando el texto original
            if (segment.toLowerCase() === entityName.toLowerCase()) {
              segment = prefix + segment;
            }
            return_milestone.splice(i + offset, 0, segment);
            offset++;
          }
          i += offset - 1;
        }
        return return_milestone;
      }, currentMilestone);
    };

    /* 1. DRIVERS */
    let transformed = processEntities(drivers, "{DR}", milestone_array);

    /* 2. TEAMS */
    transformed = processEntities(teams, "{TE}", transformed);

    /* 3. GPS */
    transformed = processEntities(grandsPrixNames, "{GP}", transformed);

    /* Renderizado final de los componentes React */
    let output_milestone: any = <></>;
    return transformed.reduce(
      (previous_milestone: any, current_position: any) => {
        if (current_position.startsWith("{DR}")) {
          let driver = current_position.split("{DR}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:Driver")}/${encodeURIComponent(driver)}`}
                className="driver"
              >
                {driver}
              </Link>
            </>
          );
        } else if (current_position.startsWith("{TE}")) {
          let team = current_position.split("{TE}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:Team")}/${encodeURIComponent(team)}`}
                className="driver"
              >
                {team}
              </Link>
            </>
          );
        } else if (current_position.startsWith("{GP}")) {
          let gp = current_position.split("{GP}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:GrandPrix")}/${encodeURIComponent(gp.replace(/ /g, ""))}`}
                className="driver"
              >
                {gp}
              </Link>
            </>
          );
        }
        return (
          <>
            {previous_milestone}
            <span>{current_position}</span>
          </>
        );
      },
      output_milestone,
    );
  };

  // Definición de mapeos de iconos por categorías e hito (key)
  const milestoneIconsMap = {
    // 1. Poles y Clasificación
    stopwatch: [
      "FirstUniquePole",
      "FirstUniquePole_plural",
      "FirstPole",
      "FirstPole_plural",
      "BestQPos",
      "BestQPos_plural",
      "EqualQPos",
      "EqualQPos_plural",
      "RoundPoles",
      "RoundPoles_plural",
      "PoleAfterTime",
      "FirstNatPole",
      "FirstNatPole_plural",
      "FirstNatUniquePole",
      "FirstNatUniquePole_plural",
      "ConsecutivePole",
      "BreakConsecutivePole",
      "LowQGap1",
      "LowQGap2",
      "LowQGap3",
      "HighQGap1",
      "HighQGap2",
      "HighQGap3",
      "TopPoles",
      "TopPolesNat",
      "TopPolesMultiple",
      "TopPolesCombined",
      "TopPolesCombined2",
      "RoundPoleCircuit",
      "NoPoleAfterTimeLayout",
      "NoPoleFirstTimeSeason",
      "DifferentPolemans_plural",
    ],

    // 2. Victorias y Podios
    trophy: [
      "FirstUniqueWin",
      "FirstUniqueWin_plural",
      "FirstWin",
      "FirstWin_plural",
      "BestRPos",
      "BestRPos_plural",
      "EqualRPos",
      "EqualRPos_plural",
      "RoundWins",
      "RoundWins_plural",
      "FirstNatWin",
      "FirstNatWin_plural",
      "FirstNatUniqueWin",
      "FirstNatUniqueWin_plural",
      "WinAfterTime",
      "FirstUniquePodium",
      "FirstUniquePodium_plural",
      "FirstPodium",
      "FirstPodium_plural",
      "RoundPodiums",
      "RoundPodiums_plural",
      "FirstNatPodium",
      "FirstNatPodium_plural",
      "FirstNatUniquePodium",
      "FirstNatUniquePodium_plural",
      "PodiumAfterTime",
      "ConsecutiveWin",
      "BreakConsecutiveWin",
      "ConsecutivePodium",
      "BreakConsecutivePodium",
      "LowRGap1",
      "LowRGap2",
      "LowRGap3",
      "HighRGap1",
      "HighRGap2",
      "HighRGap3",
      "TightRGap",
      "TopWins",
      "TopWins_plural",
      "TopWinsNat",
      "TopWinsMultiple",
      "TopWinsCombined",
      "TopWinsCombined2",
      "TopPodiums",
      "TopPodiums_plural",
      "TopPodiumsNat",
      "TopPodiumsMultiple",
      "TopPodiumsCombined",
      "TopPodiumsCombined2",
      "RoundWinCircuit",
      "NoWinAfterTimeLayout",
      "RoundPodiumCircuit",
      "NoPodiumAfterTimeLayout",
      "FirstRoundPodiumsNatSame",
      "RoundPodiumsNatSameIndex",
      "NoWinFirstTimeSeason",
      "NoPodiumFirstTimeSeason",
      "NoPodiumFirstTimeSeason_plural",
      "DifferentWinners_plural",
      "PoleEqualsWinStreak",
    ],

    // 3. Vueltas Rápidas y Récords (Hat-Tricks / Grand Chelem)
    bolt: [
      "FirstUniqueFatestLap",
      "FirstUniqueFatestLap_plural",
      "FirstFatestLap",
      "FirstFatestLap_plural",
      "RoundFatestLaps",
      "RoundFatestLaps_plural",
      "FirstNatFatestLap",
      "FirstNatFatestLap_plural",
      "FirstNatUniqueFatestLap",
      "FirstNatUniqueFatestLap_plural",
      "FastestLapAfterTime",
      "FirstUniqueHatTricks",
      "FirstUniqueHatTricks_plural",
      "FirstHatTricks",
      "FirstHatTricks_plural",
      "RoundHatTricks",
      "RoundHatTricks_plural",
      "FirstNatHatTricks",
      "FirstNatHatTricks_plural",
      "FirstNatUniqueHatTricks",
      "FirstNatUniqueHatTricks_plural",
      "HatTricksAfterTime",
      "HatTrick",
      "FirstUniqueGrandChelem",
      "FirstUniqueGrandChelem_plural",
      "FirstGrandChelem",
      "FirstGrandChelem_plural",
      "RoundGrandChelems",
      "RoundGrandChelems_plural",
      "FirstNatGrandChelems",
      "FirstNatGrandChelems_plural",
      "FirstNatUniqueGrandChelems",
      "FirstNatUniqueGrandChelems_plural",
      "GrandChelemAfterTime",
      "GrandChelem",
      "AlmostGrandChelem",
      "ConsecutiveFastestLap",
      "BreakConsecutiveFastestLap",
      "TopFastestLaps",
      "TopFastestLaps_plural",
      "TopFastestLapsNat",
      "TopFastestLapsMultiple",
      "TopFastestLapsCombined",
      "TopFastestLapsCombined2",
      "TopHatTricks",
      "TopHatTricksNat",
      "TopHatTricksMultiple",
      "TopHatTricksCombined",
      "TopHatTricksCombined2",
    ],

    // 4. Puntos y Campeonatos
    medal: [
      "FirstUniquePoints",
      "FirstUniquePoints_plural",
      "FirstPoints",
      "FirstPoints_plural",
      "RoundPoints",
      "RoundPoints_plural",
      "FirstNatPoints",
      "FirstNatPoints_plural",
      "FirstNatUniquePoints",
      "FirstNatUniquePoints_plural",
      "PointsAfterTime",
      "ConsecutivePoints",
      "BreakConsecutivePoints",
      "TopPoints",
      "TopPoints_plural",
      "TopPointsNat",
      "TopPointsMultiple",
      "TopPointsCombined",
      "TopPointsCombined2",
      "DriverChampionClass",
      "DriverChampion",
      "DriverChampion_plural",
      "DriverChampionFinal",
      "DriverChampionFinal_plural",
      "DriverChampionFinalClass",
      "TeamChampionClass",
      "TeamChampion",
      "TeamChampion_plural",
      "TeamChampionFinal",
      "TeamChampionFinal_plural",
      "TeamChampionFinalClass",
      "FirstChampLeadEver",
      "FirstChampLeadEver_plural",
      "FirstChampLeadLastRace",
      "FirstChampLeadLastRaceClass",
      "FirstChampLead",
      "FirstChampLead_plural",
      "FirstPointsSeason",
      "FirstPointsSeason_plural",
      "NoPointsFirstTimeSeason",
      "NoPointsFirstTimeSeason_plural",
      "FirstAllDriversPointsSeason",
      "FirstAllDriversPointsSeason_plural",
      "NoPointsAllDriversFirstTimeSeason",
      "NoPointsAllDriversFirstTimeSeason_plural",
    ],

    // 5. Participaciones, Debuts y Carreras
    car: [
      "Debut",
      "Debut_plural",
      "DebutDN",
      "DebutDN_plural",
      "RaceAfterTime",
      "RoundRaces",
      "RoundRaces_plural",
      "FirstTeam12",
      "Team12",
      "TopRaces",
      "TopRacesNat",
      "TopRacesCombined",
      "TopRacesCombined2",
      "FirstEverRace",
      "FirstNatEverRace",
      "FirstNatEverRace_plural",
      "RoundNatGameRace",
      "RoundNatLayoutRace",
      "RoundNatGameRaceCombined",
      "FinishRank1",
      "FinishRank2",
      "FinishRank3",
      "MaxParticipants1",
      "MaxParticipants2",
      "MaxParticipants3",
      "MinParticipants1",
      "MinParticipants2",
      "MinParticipants3",
      "MostLeaders1",
      "MostLeaders2",
      "MostLeaders3",
      "FirstAllFinishes",
    ],

    // 6. Abandonos y Fiabilidad
    exclamation: [
      "FirstRet",
      "FirstRet_plural",
      "RetAfterTimeWithRecord",
      "RetAfterTime",
      "TopFinalizing",
      "TopFinalizing_plural",
      "TopFinalizingNat",
      "TopFinalizingMultiple",
      "TopFinalizingCombined",
      "TopFinalizingCombined2",
      "TopRetiring",
      "TopRetiring_plural",
      "TopRetiringNat",
      "TopRetiringMultiple",
      "TopRetiringCombined",
      "TopRetiringCombined2",
      "DNFRank1",
      "DNFRank2",
      "DNFRank3",
      "HighDNFRatio",
      "NCText",
      "NCText_plural",
    ],

    // 7. Tiempos y Duraciones
    clock: [
      "MinRaceTime1",
      "MinRaceTime2",
      "MinRaceTime3",
      "MaxRaceTime1",
      "MaxRaceTime2",
      "MaxRaceTime3",
      "time.days_one",
      "time.days_other",
      "time.years_exact_one",
      "time.years_exact_other",
      "time.years_and_half_one",
      "time.years_and_half_other",
    ],

    // 8. Récords Negativos / Sin suerte
    frown: [
      "MostRacerNoPoints",
      "MostRacerNoPointsV2",
      "MostRacerNoPodium",
      "MostRacerNoPodiumV2",
      "MostRacerNoWin",
      "MostRacerNoWinV2",
      "MostRacerNoPole",
      "MostRacerNoPoleV2",
    ],
  };

  // Función auxiliar para obtener el icono dinámico basándose en la key
  const getMilestoneIcon = (milestone_key: string) => {
    // Si no hay milestone o no tiene key, devuelve el icono por defecto
    if (!milestone_key) return faCircleInfo;

    if (milestoneIconsMap.stopwatch.includes(milestone_key)) return faStopwatch;
    if (milestoneIconsMap.trophy.includes(milestone_key)) return faTrophy;
    if (milestoneIconsMap.bolt.includes(milestone_key)) return faBolt;
    if (milestoneIconsMap.medal.includes(milestone_key)) return faMedal;
    if (milestoneIconsMap.car.includes(milestone_key)) return faCarSide;
    if (milestoneIconsMap.exclamation.includes(milestone_key))
      return faTriangleExclamation;
    if (milestoneIconsMap.clock.includes(milestone_key)) return faClock;
    if (milestoneIconsMap.frown.includes(milestone_key)) return faCircleXmark;

    return faCircleInfo; // Por defecto si no coincide con ninguna
  };

  if (loading) return <LoadingContent />;
  if (grandPrix.name === "" || grandprix == null) return <ErrorPage />; //just in case gp name does not exist
  return (
    <div className="full-height padding-lg app-container page-transition">
      <GrandPrixNavbar name={grandprix} active={1} />
      <div id="index-gp-container" className="row">
        <div className={widthCont}>
          <div
            className="flex"
            id={grandPrix.conference !== null ? "gp-data-withconf" : "gp-data"}
          >
            <div className="col-md-6">
              <div id="gp-overview" className="news-item frame-sm">
                <p className="main-title noBottomMargin frame-title">
                  {t("Summary").toUpperCase()}
                </p>
                <div id="summary-data-content">
                  <p className="flex">
                    <FontAwesomeIcon icon={faCalendarDay} />
                    <b>{t("Date")}: </b>
                    <DateFormat
                      date={grandPrix.date.toString()}
                      format={"normal"}
                    />
                  </p>
                  <p className="flex">
                    <FontAwesomeIcon icon={faLocationPin} />
                    <b>
                      {grandPrix.rally_circuits == null
                        ? t("Circuit")
                        : t("Stages")}
                      :{" "}
                    </b>
                    <span>
                      {grandPrix.rally_circuits == null
                        ? grandPrix.layout === null
                          ? `${grandPrix.circuit_name}`
                          : `${grandPrix.circuit_name} (${grandPrix.layout.replace(/\s+V\d+$/, "")})`
                        : `${grandPrix.rally_circuits}`}
                    </span>
                  </p>
                  {grandPrix.turns > 0 && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faBacon} />
                      <b>{t("Turns")}: </b>
                      <span>{grandPrix.turns}</span>
                    </p>
                  )}
                  {grandPrix.length != null && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faRuler} />
                      <b>{t("Length")}: </b>
                      <span>
                        {parseFloat(grandPrix.length.toString()).toFixed(3)} km
                      </span>
                    </p>
                  )}
                  {grandPrix.country !== null && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faMapLocation} />
                      <b>{t("Location")}: </b>
                      <span>
                        <Flag
                          flag_code={grandPrix.flag_code}
                          name={grandPrix.country}
                        />
                        {t(`countries:${grandPrix.country}`)}
                      </span>
                    </p>
                  )}
                  <SummaryResults
                    polemans={Array.isArray(poleman) ? poleman : [poleman]}
                    winners={winner}
                    fastestlaps={fastestLap}
                  />
                  {/* 
                  {typeRaces !== 1 && poleman != null && (
                    <SummaryDrivers
                      code="PO"
                      translation="Polesitter"
                      drivers={}
                      icon={faGaugeHigh}
                    />
                  )}
                  <SummaryDrivers
                    code="WI"
                    translation="Winner"
                    drivers={winner}
                    icon={faTrophy}
                  />
                  <SummaryDrivers
                    code="FL"
                    translation="HotLap"
                    drivers={fastestLap}
                    icon={faGaugeHigh}
                  />*/}
                </div>
                {report.length > 0 && (
                  <>
                    <hr></hr>
                    <p className="main-title noBottomMargin frame-title">
                      {t("FeaturedNews").toUpperCase()}
                    </p>
                    <div
                      className="race-report flex"
                      onClick={() => {
                        navigate(
                          `${t("routes:News")}/${
                            grandPrix.champ_name == null
                              ? "LVF1"
                              : grandPrix.champ_name.replace(/ /g, "")
                          }/${report[0].id}`,
                        );
                      }}
                    >
                      <img
                        alt={grandPrix.name}
                        src={`/assets/News/${report[0].id}/Image.jpg`}
                      />
                      <div>
                        <h4>
                          {i18n.language === "es"
                            ? report[0].title_es
                            : report[0].title_en}
                        </h4>
                        <span>
                          {i18n.language === "es"
                            ? report[0].caption_es
                            : report[0].caption_en}
                        </span>
                        <Button text={t("ExpandNews")} />
                      </div>
                    </div>
                  </>
                )}
                {grandPrix.conference !== null && (
                  <div id="press-conference">
                    <hr></hr>
                    <p className="main-title noBottomMargin frame-title">
                      {t("PressConference").toUpperCase()}
                    </p>
                    <iframe
                      id="audio_53222826"
                      scrolling="no"
                      height="200"
                      width="100%"
                      src={`https://www.ivoox.com/player_ej_${grandPrix.conference}_6_1.html?c1=101010`}
                      loading="lazy"
                    ></iframe>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 flex-around">
              <div id={circuitContainer} className="news-item frame-sm">
                <p className="main-title frame-title noBottomMargin">
                  {grandPrix.circuit_name.toUpperCase()}
                </p>
                <div>
                  {grandPrix.circuit_id !== null &&
                    (grandPrix.circuit_id.includes(",") ? (
                      <CircuitTransition
                        circuits_id={grandPrix.circuit_id}
                        circuits_name={grandPrix.rally_circuits}
                        id_canvas={`circuit-${grandPrix.id}`}
                      />
                    ) : (
                      <CircuitLayout
                        circuit_id={grandPrix.circuit_id}
                        id_canvas={`circuit-${grandPrix.id}`}
                      />
                    ))}
                </div>
              </div>
              {milestonesAuto.length + milestonesTrans.length > 0 && (
                <div id="milestones-container" className="news-item frame-sm">
                  <p className="main-title frame-title noBottomMargin">
                    {t("Milestones").toUpperCase()}
                  </p>
                  <div className="milestones-data">
                    {milestonesTrans.map((milestone: any, index) => {
                      return (
                        <p key={index}>
                          <FontAwesomeIcon icon={faCircleInfo} />{" "}
                          {getMilestoneLinked(milestone.description)}
                        </p>
                      );
                    })}
                    {milestonesAuto.map((milestone: any, index) => {
                      return (
                        <p key={index}>
                          <FontAwesomeIcon
                            icon={
                              milestone.milestone == null
                                ? getMilestoneIcon(milestone.key)
                                : faCircleInfo
                            }
                          />{" "}
                          {getMilestoneLinked(
                            processMilestoneAuto(milestone, t),
                          )}
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-4">
          {grandPrix.pole_video && (
            <div className="video-container news-item frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {(typeRaces !== 1
                  ? t("PoleVideo")
                  : t("FastestLapVideo")
                ).toUpperCase()}
              </p>
              <iframe
                id="ytplayer"
                width="100%"
                allowFullScreen
                src={`https://www.youtube.com/embed/${grandPrix.pole_video}`}
              />
            </div>
          )}
          {grandPrix.gp_video && (
            <div className="video-container news-item frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {t("GPVideo").toUpperCase()}
              </p>
              <iframe
                id="ytplayer"
                width="100%"
                allowFullScreen
                src={`https://www.youtube.com/embed/${grandPrix.gp_video}`}
              />
            </div>
          )}
          {photoGP !== "" && (
            <div className="image-container news-item frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {t("PhotoGP").toUpperCase()}
              </p>
              <div className="flex-center">
                <img alt={grandPrix.name} src={photoGP} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GrandPrix;
